import { Link, useLocation } from 'react-router-dom';
import { resolveBreadcrumb } from '../lib/breadcrumb';
import { useBreadcrumbCtx } from '../lib/BreadcrumbContext';
import './site-header.css';

function SiteHeader({ ctx }) {
  const location = useLocation();
  const providedCtx = useBreadcrumbCtx();
  const crumbs = resolveBreadcrumb(location, ctx ?? providedCtx);
  const lastIndex = crumbs.length - 1;
  return (
    <header className="site-header">
      <Link to="/" className="site-wordmark" aria-label="whatshoveringover home">
        <span className="site-wordmark-mute">whats</span>hovering<span className="site-wordmark-mute">over</span>.me
      </Link>
      {crumbs.length > 0 && (
        <nav className="site-breadcrumb" data-testid="site-breadcrumb" aria-label="breadcrumb">
          {crumbs.map((c, i) => {
            const isLast = i === lastIndex;
            const linkable = !isLast && c.href;
            return (
              <span key={i} className="site-breadcrumb-seg">
                {i > 0 && <span className="site-breadcrumb-sep" aria-hidden>›</span>}
                {linkable ? (
                  <Link to={c.href} className="site-breadcrumb-link">
                    {c.label}
                  </Link>
                ) : (
                  <span aria-current={isLast ? 'page' : undefined}>{c.label}</span>
                )}
              </span>
            );
          })}
        </nav>
      )}
    </header>
  );
}

export default SiteHeader;
